import "./Runner.css";
import { Button } from "./Button";
import { Alert } from "./Card";
import { Field, Input } from "./Field";
import { leftText } from "./Runner";
import { isLoopback } from "../lib/gitconn";
import type { OAuthRequest } from "../lib/gitconn";
import { tx } from "../i18n";

/* ══ MCP 연결 요청 카드 — 채택 시안 Figma 24:2 ══
   러너 페어링의 요청 카드(`PairRequestCard`)와 같은 모양. 상태는 부르는 쪽(`OAuthApprovePage`)이 든다 —
   패턴 페이지가 같은 카드를 견본 값으로 그린다. 토큰은 어느 카드에도 없다. */

export function OAuthAskCard({
  req,
  name,
  onName,
  busy,
  error,
  onApprove,
  onDeny,
  now,
}: {
  req: OAuthRequest;
  name: string;
  onName: (v: string) => void;
  busy: "approve" | "deny" | null;
  error?: string | null;
  onApprove: () => void;
  onDeny: () => void;
  /** 남은 시간을 셀 기준 시각 — 패턴 페이지가 고정 값을 넘긴다. */
  now?: number;
}) {
  return (
    <section className="b-card rpair rpair--narrow" aria-live="polite">
      <h3 className="b-card-title">{tx("oauth.ask", { client: req.clientName })}</h3>
      <p className="muted">{tx("oauth.lead")}</p>
      <dl className="rpair__facts">
        <dt>{tx("oauth.client")}</dt>
        <dd>{req.clientName}</dd>
        <dt>{tx("oauth.redirect")}</dt>
        <dd className="rpair__mono">{req.redirectUri}</dd>
        <dt>{tx("oauth.when")}</dt>
        <dd>{tx("oauth.whenText", { left: leftText(req.expiresAt, now ?? Date.now()) })}</dd>
      </dl>
      {/* 루프백이 아니면 한 번 더 — 남의 서비스로 코드가 가는 길이다. */}
      {isLoopback(req.redirectUri) ? null : <Alert tone="warning">{tx("oauth.notLoopback")}</Alert>}
      <form
        className="rnew__form"
        onSubmit={(e) => {
          e.preventDefault();
          onApprove();
        }}
      >
        <Field label={tx("oauth.name")} hint={tx("oauth.nameHint")}>
          {(fid) => <Input id={fid} autoComplete="off" spellCheck={false} value={name} onChange={(e) => onName(e.target.value)} required />}
        </Field>
        {error ? <Alert tone="error">{error}</Alert> : null}
        <div className="rnew__actions">
          <Button type="button" loading={busy === "deny"} disabled={!!busy} onClick={onDeny}>
            {tx("oauth.deny")}
          </Button>
          <Button type="submit" variant="primary" loading={busy === "approve"} disabled={!!busy}>
            {tx("oauth.approve")}
          </Button>
        </div>
      </form>
    </section>
  );
}

export function OAuthEndCard({ kind, name }: { kind: "approved" | "denied" | "missing"; name?: string }) {
  return (
    <section className={`b-card rpair rpair--narrow${kind === "approved" ? " is-done" : ""}`} aria-live="polite">
      <h3 className="b-card-title">{tx(`oauth.${kind}.title`, { name: name ?? "" })}</h3>
      {kind === "approved" ? <Alert tone="success">{tx("oauth.approved.note")}</Alert> : null}
      <p className="muted">{tx(`oauth.${kind}.desc`)}</p>
      {kind === "approved" ? (
        <div className="rnew__actions">
          <Button onClick={() => (location.hash = "#/settings?tab=mcp")}>{tx("oauth.approved.runners")}</Button>
        </div>
      ) : null}
    </section>
  );
}
